import { Injectable } from '@angular/core';
import { FilterModel } from '@ui/shared/util-filter';
import { Observable } from 'rxjs';

/**
 * Tracks inputs made in filter elements (such as category selection or text search).
 * Components should rely on this service when changes to selected filters should update content (including map data).
 *
 * Should update all filters when one filter changes.
 */
@Injectable()
export abstract class FilterState {

    public abstract activeFilters$: Observable<Map<string, FilterModel>>;

    public abstract closeAllOverlays$: Observable<void>;

    /**
     * Sets or unsets a single active filter. Should update `activeFilters$` in the process.
     *
     * @param filter The single changed filter data.
     */
    public abstract setActiveFilter(filter: FilterModel): void;

    /**
     * Removes all active filters in order to reset the filter elements.
     */
    public abstract resetActiveFilters(): void;

    /**
     * Triggers all filters to close their overlays, if existent;
     */
    public abstract closeAllOverlays(): void;

}
